import { clsx } from 'clsx';

import { Avatar, Icon, Typography } from '@/ui';

import type { Session } from '@/types';
import type { FC, ReactNode } from 'react';

export const CoachHeader: FC<{ session: Session }> = ({ session }) => (
  <div className="flex items-center gap-3">
    <Avatar
      firstName={session.coach.firstName}
      lastName={session.coach.lastName}
      size="s"
      src={session.coach.avatarUrl}
    />
    <Typography className="text-sm font-medium">
      {session.coach.fullName}
    </Typography>
  </div>
);

export const DetailRow: FC<{ children: ReactNode; icon: string }> = ({
  children,
  icon,
}) => (
  <div className="flex items-start gap-3 text-cement-400">
    <Icon className="text-xl">{icon}</Icon>
    <Typography className="text-base">{children}</Typography>
  </div>
);

export const SessionCardShell: FC<{
  children: ReactNode;
  className?: string;
}> = ({ children, className }) => (
  <section
    className={clsx(
      'flex w-full max-w-lg flex-col gap-6 rounded-xl border border-cement-200 bg-white p-8 shadow-md',
      className,
    )}
  >
    {children}
  </section>
);
